var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuestions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}.b{fill:red;}.c{fill:#707070;}.d{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb5cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b36fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-291 -1594.895)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 60,
    height: 60,
    transform: "translate(291 1594.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1,1V59H59V1H1M0,0H60V60H0Z",
    transform: "translate(291 1594.895)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,6.565A6.571,6.571,0,0,1,6.565,0h39.39a6.571,6.571,0,0,1,6.565,6.565V36.108a6.571,6.571,0,0,1-6.565,6.565H31.728L19.039,52.192a1.657,1.657,0,0,1-1.723.154,1.615,1.615,0,0,1-.9-1.467V42.673H6.565A6.571,6.571,0,0,1,0,36.108Zm17.418,5.467-.041.123A2.459,2.459,0,1,0,22.013,13.8l.041-.123a.817.817,0,0,1,.769-.544H28.8a1.549,1.549,0,0,1,.769,2.893l-4.544,2.606a2.457,2.457,0,0,0-1.241,2.134v1.4a2.462,2.462,0,0,0,4.924.041l3.313-1.9A6.477,6.477,0,0,0,28.8,8.206h-5.97a5.75,5.75,0,0,0-5.416,3.826ZM29.543,31.184a3.283,3.283,0,1,0-3.283,3.283A3.283,3.283,0,0,0,29.543,31.184Z",
    transform: "translate(294.75 1598.635)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestions);
export default __webpack_public_path__ + "static/media/iconQuestions.6ff6aacb183e860e9cabb2aa8366309f.svg";
export { ForwardRef as ReactComponent };